<template>
  <el-container id="app">
    <v-head></v-head>
    <div style="margin-top:100px;">
      <div v-if="btnFlag" class="go-top" @click="backTop">
        <img src="./assets/images/btn_top.png" />
      </div>
      <div class="online-box">
        <a
          target="_blank"
          href="https://yzf.qq.com/xv/web/static/chat/index.html?sign=37ef9b97847d53c52615cabd4ab5b330494f6b08a2a99cb5bb201c9368ae3a5ba9243d144fab788dadd242d899a622acbdf3f5"
        >
          <img src="./assets/images/icon_online.png" />
        </a>
      </div>
      <router-view></router-view>
    </div>
    <v-footer v-if="!$route.meta.keepAlive"></v-footer>
  </el-container>
</template>

<script>
import vHead from "./components/common/header.vue";
import vFooter from "./components/common/footer.vue";
export default {
  name: "App",
  data() {
    return {
      btnFlag: false
    };
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
  methods: {
    backTop() {
      let that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
    scrollToTop() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 120) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    }
  },
  components: {
    vHead,
    vFooter
  }
};
</script>

<style>
@import "../static/font/font.css";
#app {
  min-width: 1400px;
  margin: 0 auto;
  /* max-width: 1500px; */
  color: #202020;
  /* font-family: "PingFang","Ding"; */
  flex-direction: column;
}
::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}
::-webkit-scrollbar-thumb {
  background-color: rgb(223, 223, 223);
  background-clip: padding-box;
  min-height: 28px;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}
::-webkit-scrollbar-thumb:hover {
  background-color: rgb(194, 194, 194);
}
.go-top img,
.online-box img {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  object-fit: cover;
}
.online-box,
.go-top {
  position: fixed;
  text-align: center;
  right: 50px;
  z-index: 1000;
  width: 50px;
  height: 50px;
  transition: all 0.4s;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.185);
  cursor: pointer;
}
.online-box {
  bottom: 170px;
}
.go-top {
  bottom: 100px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue